import type { TAspectRatio } from './types';

const aspectRatioMap: Record<TAspectRatio, number> = {
  '1x1': 1,
  '4x3': 4 / 3,
  '16x9': 16 / 9,
};

export function camerasGridPropertiesCalculator(
  aspectRatio: TAspectRatio,
  { gridH, gridW }: { gridH: number; gridW: number },
  camerasQuantity: number,
  cameraMinWidth = 250,
) {
  const safeGridW = Math.max(1, gridW);
  const safeGridH = Math.max(1, gridH);
  let columns = Math.floor(safeGridW / cameraMinWidth);
  columns = Math.min(columns, camerasQuantity);
  columns = Math.max(1, columns);
  const cameraWidth = safeGridW / columns;
  let cameraHeight = cameraWidth / aspectRatioMap[aspectRatio];
  let rows = Math.floor(safeGridH / cameraHeight);
  cameraHeight = Math.min(cameraHeight, safeGridH);
  rows = Math.max(1, rows);

  return { rows, columns, cameraWidth, cameraHeight };
}
